import { Routes, Route } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Router } from 'framework/routing';
import { VIEW_STAFFING_DASHBOARD } from '../constants';
import OpportunityDashboard from './List/OpportunityDashboard';
import { OPPORTUNITY_DASHBOARD_PATH } from 'domain/shared/core/sharedRouteConstants';

const StaffingOpportunityRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  return (
    <ProtectedRouter basePath={OPPORTUNITY_DASHBOARD_PATH}>
      <Routes>
        <Route
          index
          element={
            <GlobalProtectedRoute globalPermissionToCheck={VIEW_STAFFING_DASHBOARD}>
              <OpportunityDashboard />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

StaffingOpportunityRouter.getRouterPath = () => `${OPPORTUNITY_DASHBOARD_PATH}/*`;

export default StaffingOpportunityRouter;
